// Daily Check-In prompts for the Four Pillars (REV) coaching area.
// Informative, tick-if-true statements so clients learn to check in on the go.
// Edit / add / remove prompts freely here.

export const CHECKIN_PILLARS = [
  {
    key: 'body',
    title: 'The Body',
    dot: '#8a72b0',
    prompts: [
      "I've had roughly 1.5–2 L of clean, quality water today.",
      'I supported hydration with minerals or trace minerals (sea moss, quality salt, silica, clean electrolytes).',
      'I supported gentle detox / elimination (fibre, binders like DE or chlorella, sweat, movement).',
      'I nourished with fat, fibre and protein to keep my blood sugar steady.',
      'I moved, mobilised or breathed with intention today — even a little counts.',
    ],
  },
  {
    key: 'mind',
    title: 'The Mind',
    dot: '#6f8f5f',
    prompts: [
      'I noticed the thoughts running in the background — without judging them.',
      'I caught a limiting thought and offered myself a kinder, truer one.',
      'I met a challenge with curiosity instead of criticism.',
      'I connected something I did today to my bigger vision for my vitality.',
      'I paused before reacting, giving my mind a moment to choose.',
    ],
  },
  {
    key: 'emotional',
    title: 'The Emotional',
    dot: '#c0845c',
    prompts: [
      'I let myself feel an emotion today instead of pushing it away.',
      'I named what I was feeling — gave the emotion a word.',
      'I expressed or moved an emotion (spoke it, wrote it, breathed or shook it out).',
      'I noticed a stress response and gently regulated (breath, pause, softening).',
      'I offered myself compassion around something that felt hard.',
    ],
  },
  {
    key: 'energetic',
    title: 'The Energetic',
    dot: '#7d94ad',
    prompts: [
      'I took a few conscious breaths to come into presence today.',
      'I noticed my energy levels and honoured what they were telling me.',
      'I did something nourishing for my spirit, not just my to-do list.',
      'I connected to something larger than myself (nature, stillness, gratitude).',
      'I trusted a gut feeling or a moment of inner guidance today.',
    ],
  },
];

export const TOTAL_PROMPTS = CHECKIN_PILLARS.reduce((n, p) => n + p.prompts.length, 0);
